import React from 'react';
import CustomReactPaginate from '../../../common/custom/CustomReactPaginate';
import showAlert from '../../../common/utils/alert';
import { ChatGptTable } from './ChatGptTable';
import { useDispatch } from 'react-redux';

export const ChatGptList = ({
  version,
  actions,
  projectId,
  externalapi,
  page,
  limit,
  onPageChange,
}) => {
  const { deleteExternalApi, cloneExternalApi } = actions;

  const dispatch = useDispatch();

  const handleDelete = (uuid) => {
    const text = "You won't be able to revert this.";
    const preConfirm = () => {
      dispatch(deleteExternalApi({ uuid, projectId, version }));
    };
    const confirmButtonText = 'Yes, delete it!';
    showAlert(text, preConfirm, confirmButtonText);
  };

  const handleClone = (externalapi) => {
    const {
      externalApiName,
      bodyDataFrom,
      sendFormData,
      collectionName,
      isUpdateItemWithResponse,
      donotPersistResponseData,
      collectionMapping,
      bodyRawJSON,
      bodyCustomJSON,
      bodyCollectionMapping,
      requestDataJsonType,
      setting,
      responseDataMapping,
      externalApiType,
      timeout,
    } = externalapi;
    const data = {
      externalApiName,
      projectId,
      version,
      bodyDataFrom,
      sendFormData,
      collectionName,
      isUpdateItemWithResponse,
      donotPersistResponseData,
      collectionMapping,
      bodyRawJSON,
      bodyCustomJSON,
      bodyCollectionMapping,
      requestDataJsonType,
      setting,
      responseDataMapping,
      externalApiType,
      timeout,
    };
    const text = 'Do you want to clone this ChatGPT API?';

    const preConfirm = () => {
      cloneExternalApi(data).then(() => {
        actions.loadExternalApis({
          projectId,
          version,
          page: page,
          limit: limit,
          externalApiType: externalApiType,
        });
      });
    };
    const confirmButtonText = 'Yes, Clone it!';
    showAlert(text, preConfirm, confirmButtonText);
  };

  const { externalApis, totalExternalApisPages } = externalapi;

  if (externalApis && externalApis.length > 0) {
    return (
      <div className="table-responsive">
        <ChatGptTable
          projectId={projectId}
          version={version}
          externalapi={externalapi}
          externalApis={externalApis}
          handleClone={handleClone}
          handleDelete={handleDelete}
        />

        {totalExternalApisPages > 1 && (
          <CustomReactPaginate
            totalPages={totalExternalApisPages}
            pageRangeDisplayed={10}
            marginPagesDisplayed={2}
            page={page}
            limit={limit}
            onPageChange={onPageChange}
          />
        )}
      </div>
    );
  } else return <div className="alert">No ChatGPT API found! Please create one if needed.</div>;
};
